import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosService from '../../../utility/axiosService/axiosService';
import { API_ENDPOINT } from '../../../utility';
import { toast } from 'react-toastify';

export const updateUser =  createAsyncThunk(
    'users/updateUser',
    async (data)=>{
        return await axiosService.put(`${API_ENDPOINT}/admin/user/${data.id}`, {
                status: data.status === 1 ? 0 : 1
        }).then((res)=>{
            return res.data;
        })
    }
)
export const closeSnackbar =  createAsyncThunk(
    'users/closeSnackbar',
    async (data)=>{
        console.log(data)
      
    }
)
export const getUser = createAsyncThunk(
    'users/getUser',
    async (data) => {
        if (data === 'all') {
            return await axiosService
                .get(`${API_ENDPOINT}/admin/user`, {
                    params: {
                        limit: 10,
                        page: data.page,
                    }
                })
                .then((res) => {
                    return res.data;
                });
        } else {
            return await axiosService
                .get(`${API_ENDPOINT}/admin/user`, {
                    params: data
                        ? {
                              page: data.page,
                              search: data.keyword !== '' ? data.keyword  : null,
                              limit: 10
                          }
                        : {
                              page: 1,
                              limit: 100
                          }
                })
                .then((res) => {
                    console.log(res)
                    return res.data;
                });
        }
    }
);
export const findUser = createAsyncThunk('users/findUser', async (dataFilter) => {
    return await axiosService
        .get(`${API_ENDPOINT}/admin/contact-consultant`, {
            params: {
                limit: 100
            }
        })
        .then((res) => {
            const finddataUser = res.data.data.result.filter(
                (item) => item.name.toLowerCase() != null && item.name.toLowerCase().includes(dataFilter.toLowerCase())
            );
            return finddataUser;
        });
});
const campaignUserSlice = createSlice({
    name: 'campaignUser',
    initialState: {
        loading: false,
        modal: false,
        toast:false,
        data: [],
        total_page: 0,
        dataCampaignUser: [],
        finddataUser:[],
        upadateUser:{},
        dataDetailsUser: null,
        error: null,
        keyword: "",
        page: 1,
        dataFilter: {
            keyword: '',
            page: 1
        }
    },
    reducers: {
        getModal: (state, { payload }) => {
            state.modal = true;
            state.dataDetails = payload;
        },
        removeModal: (state) => {
            state.dataDetails = null;
            state.modal = false;
        },
        searchTextFieldSlice: (state, { payload }) => {
            state.keyword = payload.data;
        },
        paginationHandleSlice: (state, { payload }) => {
            state.page = payload.data;
        },
        filterData: (state, { payload }) => {
            state.dataFilter.keyword = payload.page
                ? payload.keyword || state.dataFilter.keyword
                : payload.keyword;
            state.dataFilter.page = payload.page || state.dataFilter.page;
        }
    },
    extraReducers: {
        
        [getUser.pending]: (state) => {
            state.loading = true;
        },
        [getUser.fulfilled]: (state, { payload }) => {
            state.dataCampaignUser = payload.data.result;
            state.total_page = payload.data.total_page;
            state.loading = false;
        },
        [updateUser.pending]: (state) => {
            state.loading = true;
        },
        [updateUser.fulfilled]: (state, { payload }) => {
            state.upadateUser = payload.data;
            // state.toast = true
            toast.success('Cập nhật dữ liệu thành công !');
        },
        [findUser.fulfilled]: (state, { payload }) => {
            state.upadateUser = payload.data;
        },
        [closeSnackbar.fulfilled]: (state, { payload }) => {
            state.toast = false
          
        }

    }
});

export const { getModal, removeModal, filterData, searchTextFieldSlice, paginationHandleSlice } =
    campaignUserSlice.actions;

export default campaignUserSlice.reducer;
